module.exports = __webpack_public_path__ + "static/media/DSCF2843.03b4a62e.jpg";